$(document).ready(function(){

   // Product Slider Js

    function myFunction() {      
    }
   myFunction();
  
 // Product Type Js
       var pro_handle =  $(document).find("#ProductSection-product-template").attr('data-handle');
       var first_data_option = $.trim($('.first_clickyboxes_product li').find(".active_data").attr('data-value'));
       if(first_data_option != undefined){

           let searchParams = new URLSearchParams(window.location.search);
           let param = searchParams.get('Type');
           if(param == null){
             var first_data_option = $.trim($('.first_clickyboxes_product li').find(".active_data").attr('data-value'));
           }else{
              var prohandle = $(document).find('.product__info-container').attr('data-handle');
              var first_data_option = param;
              $(".first_clickyboxes_product li a").removeClass('active_data');
              $('.first_clickyboxes_product li a').each(function() {
                var data_tag = $.trim($(this).attr('data-value'));
                //console.log(data_tag + ' / ' + first_data_option);
                if(data_tag == first_data_option){
                   $(this).addClass('active_data');
                   if ($(this).hasClass('product_option_data_other')) {
                      $(document).find('.plug_type_items').show();
                   }
                }
              });


             
              var prodcut_handle = prohandle;
              var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
              history.pushState({path: newurl}, '', newurl);
  
           }

           $(".second_clickyboxes_product li a").removeClass('active');
           $(".second_clickyboxes_product li").removeClass('other_option');
              $('.second_clickyboxes_product li a').each(function() {
                var data_tag = $.trim($(this).attr('data-tags'));
                if(data_tag == first_data_option){
                   $(this).closest('li').addClass('other_option');
                }
            });
            $(".second_clickyboxes_product li.other_option:first a").addClass('active');
            var prodcut_varId = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-varid'));
            $(document).find('.product-variant-id').val(prodcut_varId);
            var prodcut_id = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-proid'));
            var prodcut_price = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-price'));

          var prodcut_data_code = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-code'));
          if(prodcut_data_code != ''){
             $(document).find('.price__regular .price-item').text('');
             $(document).find('.request_codes_btn_register').hide();
           }else{
         $(document).find('.price__regular .price-item').text(prodcut_price);
             $(document).find('.request_codes_btn_register').show();
           }
  
             var prodcut_handle = $.trim($('.second_clickyboxes_product li.other_option:first a').attr('data-value'));
             //var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
             //history.pushState({path: newurl}, '', newurl);
  
          
        $.ajax({
          url: `/products/${prodcut_handle}`,
          method: "GET",
          dataType: "html",
        }).done(function (responseText) {
          const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
          var sliderElement = $(responseHTML).find(".product__media-wrapper").prop("innerHTML");
          var varaintElement = $(responseHTML).find(".ctm_variant_quantity_align").prop("innerHTML");
          var quantityElement = $(responseHTML).find(".quantity_alert_message").prop("innerHTML");      
          var priceContainerSwym = $(responseHTML).find(".SwymGrPriceMain").html();

          
          
          $(document).find('.quantity_alert_message').html(quantityElement);
          $(document).find('.SwymGrPriceMain').html(priceContainerSwym);
          
          $(document).find('.ctm_variant_quantity_align').html(varaintElement);
          
             if(prodcut_data_code == ''){
                   $(document).find('.request_codes_btn').hide();
                   var varaintButton = $(responseHTML).find(".product-form__buttons").prop("innerHTML");
                   $(document).find('.product-form__buttons').html(varaintButton);
                   $(document).find('.request_codes_btn_without').show();
                }else{
                  $(document).find('.request_codes_btn_without').hide();
                  $(document).find('.request_codes_btn').show();
                }
          var thisSlider =  $(document).find('.product__media-wrapper').html(sliderElement);
          myFunction(thisSlider);
        }).fail(function (jqXHR, textStatus, errorThrown) {});
      
           
             $(document).find(".comapre_data").each(function() {
                 var prodcut_findId = $(this).attr('data-product');
                 if(prodcut_findId == prodcut_id){
                   $(this).show().addClass('active');
                 }else{
                   $(this).hide().removeClass('active');
                 }
              });

              setTimeout (function() {        
              var recommProductID = $(document).find(".product__description.rte.quick-add-hidden.comapre_data.active").attr("data-product");      
              var recommProductURL = `/recommendations/products?section_id=template--17435898708183__related-products&product_id=${recommProductID}&limit=4`;
              
                $.ajax({
                url: recommProductURL,
                method: "GET",
                dataType: "html",
                }).done(function (responseText) {    
                const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
                var recommHtml = $(responseHTML).find("product-recommendations").prop("innerHTML");
                $(document).find('product-recommendations').html(recommHtml);              
              }).fail(function (jqXHR, textStatus, errorThrown) {
              
              });
              },1500)
         
       }
  
     $(document).on("click", ".first_clickyboxes_product li a.product_option_data", function() {

          $(".first_clickyboxes_product li a").removeClass('active_data');
          $(".second_clickyboxes_product li a").removeClass('active');
          $(".second_clickyboxes_product li").removeClass('other_option');

          if($(this).hasClass('last_type_option')){
             $('.product_option_data_other').each(function(indexdata) {
               if(indexdata == 0){
                 $(this).addClass('active_data');
               }
             });
             $(document).find('.plug_type_items').show();
          }else{
              $(this).addClass('active_data');
              $(document).find('.plug_type_items').hide();
          }
       
          var first_data_option = $(this).attr('data-value');
            $('.second_clickyboxes_product li a').each(function() {
              var data_tag = $.trim($(this).attr('data-tags'));
              if(data_tag == first_data_option){
                 $(this).closest('li').addClass('other_option');
              }
           });
           $(".second_clickyboxes_product li.other_option:first a").addClass('active');
            var prodcut_varId = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-varid'));
            $(document).find('.product-variant-id').val(prodcut_varId);
           var prodcut_id = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-proid'));
           var prodcut_price = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-price'));

            var prodcut_data_code = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-code'));
          if(prodcut_data_code != ''){
             $(document).find('.price__regular .price-item').text('');
             $(document).find('.request_codes_btn_register').hide();
           }else{
             $(document).find('.price__regular .price-item').text(prodcut_price);
             $(document).find('.request_codes_btn_register').show();
           }
             var prodcut_handle = $.trim($('.second_clickyboxes_product li.other_option:first a').attr('data-value'));
             //var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
             //history.pushState({path: newurl}, '', newurl); 
       
              $.ajax({
                url: `/products/${prodcut_handle}`,
                method: "GET",
                dataType: "html",
              }).done(function (responseText) {
                const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
                var sliderElement = $(responseHTML).find(".product__media-wrapper").prop("innerHTML");
                var varaintElement = $(responseHTML).find(".ctm_variant_quantity_align").prop("innerHTML");
                var quantityElement = $(responseHTML).find(".quantity_alert_message").prop("innerHTML");

                var priceContainerSwym = $(responseHTML).find(".SwymGrPriceMain").html();
                $(document).find('.SwymGrPriceMain').html(priceContainerSwym);

                $(document).find('.ctm_variant_quantity_align').html(varaintElement);
                $(document).find('.quantity_alert_message').html(quantityElement);
                
                if(prodcut_data_code == '') {
                   $(document).find('.request_codes_btn').hide();
                   var varaintButton = $(responseHTML).find(".product-form__buttons").prop("innerHTML");
                   $(document).find('.product-form__buttons').html(varaintButton);
                   $(document).find('.request_codes_btn_without').show();
                } else {
                  $(document).find('.request_codes_btn_without').hide();
                  $(document).find('.request_codes_btn').show();
                }
                 
                
                var thisSlider =  $(document).find('.product__media-wrapper').html(sliderElement);
                myFunction(thisSlider);
              }).fail(function (jqXHR, textStatus, errorThrown) {});
               
              $(document).find(".comapre_data").each(function() {
                 var prodcut_findId = $(this).attr('data-product');
                 if(prodcut_findId == prodcut_id){
                   $(this).show().addClass('active');
                 }else{
                   $(this).hide().removeClass('active');
                 }
              });


      setTimeout (function() {        
        var recommProductID = $(document).find(".product__description.rte.quick-add-hidden.comapre_data.active").attr("data-product");      
        var recommProductURL = `/recommendations/products?section_id=template--17435898708183__related-products&product_id=${recommProductID}&limit=4`;
          
            $.ajax({
              url: recommProductURL,
              method: "GET",
              dataType: "html",
            }).done(function (responseText) {    
              const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
              var recommHtml = $(responseHTML).find("product-recommendations").prop("innerHTML");
              $(document).find('product-recommendations').html(recommHtml);
            
              }).fail(function (jqXHR, textStatus, errorThrown) {
              
              });
        },1500)

});

     $(document).on("click", ".first_clickyboxes_product li a.product_option_data_other", function() {

          $(".first_clickyboxes_product li a").removeClass('active_data');
          $(".second_clickyboxes_product li a").removeClass('active');
          $(".second_clickyboxes_product li").removeClass('other_option');
          $(this).addClass('active_data');
          var first_data_option = $(this).attr('data-value');
            $('.second_clickyboxes_product li a').each(function() {
              var data_tag = $.trim($(this).attr('data-tags'));
              if(data_tag == first_data_option){
                 $(this).closest('li').addClass('other_option');
              }
           });
           $(".second_clickyboxes_product li.other_option:first a").addClass('active');
            var prodcut_varId = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-varid'));
            $(document).find('.product-variant-id').val(prodcut_varId);
           var prodcut_id = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-proid'));
           var prodcut_price = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-price'));
           var prodcut_data_code = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-code'));
          if(prodcut_data_code != ''){
             $(document).find('.price__regular .price-item').text('');
             $(document).find('.request_codes_btn_register').hide();
           }else{
          $(document).find('.price__regular .price-item').text(prodcut_price);
             $(document).find('.request_codes_btn_register').show();
           }
  
             var prodcut_handle = $.trim($('.second_clickyboxes_product li.other_option:first a').attr('data-value'));
             //var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
             //history.pushState({path: newurl}, '', newurl);

          //var prodcut_data_code = $.trim($(".second_clickyboxes_product li.other_option:first a").attr('data-code'));
  
              $.ajax({
                url: `/products/${prodcut_handle}`,
                method: "GET",
                dataType: "html",
              }).done(function (responseText) {
                const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
                var sliderElement = $(responseHTML).find(".product__media-wrapper").prop("innerHTML");
                var varaintElement = $(responseHTML).find(".ctm_variant_quantity_align").prop("innerHTML");
                var quantityElement = $(responseHTML).find(".quantity_alert_message").prop("innerHTML");
                $(document).find('.quantity_alert_message').html(quantityElement);
                $(document).find('.ctm_variant_quantity_align').html(varaintElement);
               if(prodcut_data_code == ''){
                   $(document).find('.request_codes_btn').hide();
                   var varaintButton = $(responseHTML).find(".product-form__buttons").prop("innerHTML");
                   $(document).find('.product-form__buttons').html(varaintButton);
                   $(document).find('.request_codes_btn_without').show();
                }else{
                  $(document).find('.request_codes_btn_without').hide();
                  $(document).find('.request_codes_btn').show();
                }
                var thisSlider =  $(document).find('.product__media-wrapper').html(sliderElement);
                myFunction(thisSlider);
              }).fail(function (jqXHR, textStatus, errorThrown) {});
               
              $(document).find(".comapre_data").each(function() {
                 var prodcut_findId = $(this).attr('data-product');
                 if(prodcut_findId == prodcut_id){
                   $(this).show().addClass('active');
                 }else{
                   $(this).hide().removeClass('active');
                 }
              });

        setTimeout (function() {        
        var recommProductID = $(document).find(".product__description.rte.quick-add-hidden.comapre_data.active").attr("data-product");      
        var recommProductURL = `/recommendations/products?section_id=template--17435898708183__related-products&product_id=${recommProductID}&limit=4`;
          
            $.ajax({
              url: recommProductURL,
              method: "GET",
              dataType: "html",
            }).done(function (responseText) {    
              const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
              var recommHtml = $(responseHTML).find("product-recommendations").prop("innerHTML");
              $(document).find('product-recommendations').html(recommHtml);
            
              }).fail(function (jqXHR, textStatus, errorThrown) {
              
              });
        },1500)
       
     });
});